import React from 'react'
import ArticlesWidgets from './Container'
import ResourceLoader from '../ResourceLoader'

const Wrapper = props =>
  <ResourceLoader reducers={ ['articlesWidgets'] } epics={ ['articlesWidgets'] }>
    <ArticlesWidgets { ...props } />
  </ResourceLoader>

export default Wrapper
